export default {
    next: "Weiter",
    prev: "Zurück",
    submit: "Analyseanforderung senden",
    contactInformation: "Kontaktdaten",
    name: "Ihr Name",
    title: "Anrede",
    titles: [
        { id: "Frau", name: "Frau"},
        { id: "Herr", name: "Herr"},
    ],
    firstName: "Vorname",
    lastName: "Nachname",
    company: "Firma",
    country: "Land",
    city: "Stadt",
    postalCode: "PLZ",
    street: "Straße",
    email: "E-Mail",
    email2: "Zusätzliche E-Mails",
    phone: "Telefon",
    emailTooltip: "Bitte geben Sie eine oder mehrere durch <strong>Strichpunkt</strong> voneinander getrennte E-Mail Adressen an, ohne Leerzeichen zu verwenden.",
    emailError: "Bitte geben Sie eine gültige E-Mail-Adresse an!",
    email2Error: "Bitte geben Sie eine oder mehrere durch Strichpunkt voneinander getrennte E-Mail Adressen an, ohne Leerzeichen zu verwenden.",
    installationsTitle: "Angaben zu Ihrem System",
    installationName: "Anlagenbezeichnung",
    location: "Standort Anlage",
    application: "Anwendung",
    segment: "Segment",
    segmentPlaceholder: "Bitte wählen Sie zuerst eine Anwendung aus",
    product: "Produkt",
    otherProduct: "Produkt Name",
    volume: "Gesamtvolumen des Fluids (l)",
    volumeTooltip: "Gesamtvolumen des Fluids im System (l).<br/>Bitte geben Sie ein Nummer an.<br/>Sollte das Volumen unbekannt sein, bitte bestmögliche Schätzung angeben.",
    fillDate: "Datum der ersten Befüllung",
    metals: "Im System verwendete Metalle",
    otherMetals: "Andere Metalle/Materialien",
    sample: "Probe",
    addInstallation: "Probe hinzufügen",
    removeInstallation: "Probe löschen",
    removeConfirmation: "Möchten Sie diese Probe wirklich entfernen?",
    installationRemoved: "Die Probe wurde entfernt.",
    other: "Andere",
    listLoadError: "Drop-List-Daten können nicht geladen werden. Bitte kontaktieren Sie Clariant!",
    invalidFields: "Sie können nicht mit dem nächsten Schritt fortfahren, solange einige Felder Fehler aufweisen. Bitte überprüfen Sie die rot markierten Felder!",
    extraInformation: "Zusatzinformation",
    distributor: "Händler, bei dem Sie unser Fluid gekauft haben",
    otherDistributor: "Anderer Händler",
    dropdownPlaceholder: "Bitte wählen Sie eine Option",
    feedback: "Anmerkungen und Zusatzinformationen zur Probe",
    disclaimer1: "Sie erhalten eine Bestätigungsmail mit Ihrer persönlichen Sendungsnummer und der Adresse, an die das Muster gesendet werden soll.",
    disclaimer2: "Proben, die ohne Sendungsnummer eingesendet wurden, können nicht bearbeitet werden und werden nicht zurückgeschickt.",
    startOver: "Eine weitere Probe einreichen",
    confirmation: "Ihre Anfrage wurde gesendet. Sie sollten in Kürze eine Bestätigungs-E-Mail erhalten.",
    confirmation2: "Währenddessen können sie die Bestätigung(en) und Etikett(en) zur Probenkennzeichnung herunterladen:",
    invalidEmailLength: "Die kombinierte Länge der beiden E-Mail-Felder darf 189 Zeichen nicht überschreiten!",
    voucherNumber: "Vouchernummer",
    noRemainingSamples: "Diese Vouchernummer ist nicht gültig",
    emptyVoucherMsg: "Bitte geben sie eine Vouchernummer ein",
    counterVoucher: "Voucher",
    counterOutOf: "von",
    counterAreAvailable: "Proben noch verfügbar",
    voucherIntro: "<p>Please fill out the form below. The <b>information you provide</b> will automatically be used to generate the <b>analysis report</b> and <b>printable bottle labels</b>.</p><p>You will receive a confirmation email containing your personal reference number and further instructions.</p><p><strong>Samples sent in without reference numbers will neither be processed nor sent back.</strong></p><p><strong>Third-party products will not be analysed and will be disposed of directly.</strong></p>",
    termsAndConditions: "<span>I agree to the <a href='Antifrogen-Sample-Submission/Terms-And-Conditions' target='_blank'>Terms &amp; Conditions</a>.",
    wrongAppVersion: "Sie verwenden nicht die neueste Version dieses Formulars. Bitte leeren Sie Ihren Browser-Cache und versuchen Sie es erneut."
};